import './style.css';
import Arbitrator_new_logo_eng from '../../assets/images/new-logo-blue.svg';
import Arbitrator_new_logo_ru from '../../assets/images/new-logo-ru-blue.svg';
import Arbitrator_new_logo_uz from '../../assets/images/new-logo-uz-blue.svg';

const LoaderComponent = () => {
  const active_lang = localStorage.getItem('i18lang');
  return (
    <div className="loader-container">
      <div className="loader">
        <img src={active_lang == 'uz' ? Arbitrator_new_logo_uz : active_lang == 'ru' ? Arbitrator_new_logo_ru : Arbitrator_new_logo_eng} alt="logo" className="loader-logo" />
        <div className="loader-circle"></div>
      </div>
    </div>
  );
};

export default LoaderComponent;

